import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';

import BankAccountVerificationForm from './BankAccountVerificationForm';

class BankAccountVerificationFormModal extends PureComponent {
	render() {
		const { showBankAccountVerification } = this.props;
		return (
			<Modal
				keyboard={false}
				backdrop="static"
				show={showBankAccountVerification}
				onHide={this.handleOnCancel}
				className="payment-modal"
			>
				<Modal.Header
					className="bg-gray-12"
					closeButton
				>
					<Modal.Title>
						<span>Microdeposit amounts in cents</span>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<BankAccountVerificationForm />
				</Modal.Body>
			</Modal>
		);
	}
}

const mapStateToProps = ({ app : { bankAccountVerification : { show } } }) => ({
	showBankAccountVerification : show,
});

BankAccountVerificationFormModal.propTypes = {
	showBankAccountVerification : PropTypes.bool,
};

BankAccountVerificationFormModal.defaultProps = {
	showBankAccountVerification : false,
};

export default connect(mapStateToProps, null)(BankAccountVerificationFormModal);
